<template>
<section class="body-bg">
  <el-row class="container">
    <!--头部-->
    <div class="topbar-wrap">
      <div class="topbar-logo topbar-btn pull-left">
        <img src="/static/images/home/coca-cola.png" alt="">
      </div>
      <div class="topbar-title pull-left">可口可乐质检系统</div>
    </div>
  </el-row>
  <div class="main-container clearfix" style="background-color: rgb(248, 248, 248);">
    <div class="main">
      <!--左侧导航-->
      <div class="asideBox clearfix">
        <aside>
          <!-- sgp 导航 -->
          <ul class="asideMenu">
            <li v-for="(item,index) in menuList" :key="index+'ml'" >
              <div class="oneMenu" @click="showToggle(item,index)" :class="{menuActive: currentRoute(item)}">
                <div v-if="item.subItems.length > 0">
                  <img :src="currentRoute(item) ? item.activeIcon : item.icon">
                  <span>{{item.name}}</span>
                  <img :src="currentSubShow(item) ? activeArrow :arrow" v-if="item.subItems.length > 0"  class="arrow-img pull-right">
                </div>

                <router-link v-else-if="item.routerName" :to="{name: item.routerName, query: roleHandle()}" tag="div">
                  <img :src="currentRoute(item) ? item.activeIcon : item.icon">
                  <span>{{item.name}}</span>
                  <img :src="currentSubShow(item) ? activeArrow :arrow" v-if="item.subItems.length > 0"  class="arrow-img pull-right">
                </router-link>

                <a v-else :href="item.href" style="display: block;">
                  <img :src="currentRoute(item) ? item.activeIcon : item.icon">
                  <span>{{item.name}}</span>
                  <img :src="currentSubShow(item) ? activeArrow :arrow" v-if="item.subItems.length > 0"  class="arrow-img pull-right">
                </a>

              </div>
              <ul v-show="currentSubShow(item)">
                <li v-for="(item, index) in item.subItems" :key="index+'si'" >
                  <router-link v-if="!item.href" class="oneMenuChild" :class="{'router-link-active': item.routerActiveList && item.routerActiveList.includes($route.name)}" @click.native="routerConfig(item, index)" :to="{name: item.routerName, query: roleHandle()}">
                    <span class="nav-cicle"></span>
                    <span class="nav-text">{{item.name}}</span>
                  </router-link>
                  <a v-else class="oneMenuChild" :href="item.href" target="_blank">
                    <span class="nav-cicle"></span>
                    <span class="nav-text">{{item.name}}</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </aside>
      </div>
      <!--右侧内容区-->
      <section class="content-container" >
        <div class="clearfix">
          <el-col :span="24" class="content-wrapper main-content" style="background-color: #f8f8f8;">
            <transition name="fade" mode="out-in">
              <router-view v-if="isRouterAlive"></router-view>
            </transition>
          </el-col>
        </div>
      </section>
      <!-- 向上箭头 -->
      <div class="go-top" @click="goTop" v-if="scroll_top_show"><div class="go-top-img"></div></div>
    </div>
  </div>
</section>
</template>
<script>
export default {
  data(){
    return{
      isRouterAlive:true,
      sgp_link: this.$httpConfig.COLAHOST + 'Purchasing/',
      su_link: this.$httpConfig.COLAHOST + 'Vendor/',
      tl_link: this.$httpConfig.COLAHOST + 'TL/',
      scroll_top_show: false,
      scrollTop: 0,
      childActive: -1,
      su_list: ['manage-product', 'change', 'apply-change', 'manage-detail', 'su-order-quality'],
      sgp_list: ['examine-product', 'sgp-change', 'sgp-detail', 'sgp-manage-product', 'examine-change', 'sgp-manage-detail', 'sgp-order-qualify', 'sgp-report-qualify', 'sgp-review-qualify'],
      arrow: ('/static/images/home/arrow.png'),
      activeArrow: ('/static/images/home/arrow-top.png'),
      // sgp
      menuList: [],
      sgpMenuList:[
        {
          name: '产品',
          icon: ('/static/images/home/product.png'),
          activeIcon: ('/static/images/home/product-active.png'),
          isSubShow: false,
          subItems:[
            {
              name:'审核产品',
              routerName: 'examine-product',
              routerActiveList: ['examine-product', 'sgp-detail']
            },
            {
              name:'管理产品',
              routerName: 'sgp-manage-product',
              routerActiveList: ['sgp-manage-product', 'sgp-manage-detail', 'sgp-change']
            }
          ]
        },
        {
          name:'质量检测',
          icon: ('/static/images/home/product-detect.png'),
          activeIcon: ('/static/images/home/product-detect-active.png'),
          isSubShow:false,
          subItems:[
            {
              name:'质量检测订单',
              routerName: 'sgp-order-qualify',
              routerActiveList: ['sgp-order-qualify', 'sgp-review-qualify', 'sgp-apply-check']
            },
            {
              name:'复核质量检测报告',
              routerName: 'sgp-report-qualify',
              routerActiveList: ['sgp-report-qualify']
            },
            {
              name:'质量检测订单导出',
              routerName: null,
              href: this.$httpConfig.COLA + '/api/cola/sgp/export-quality-detection-order',
              routerActiveList: []
            },
            // {
            //   name:'质量报告',
            //   routerName: 'qualify-report',
            // },
          ]
        },
        {
          name:'质检模型管理',
          icon: ('/static/images/home/product-detect.png'),
          activeIcon: ('/static/images/home/product-detect-active.png'),
          isSubShow: false,
          subItems:[
            {
              name: '质检项目管理',
              routerName: 'quality-product-manage',
              routerActiveList: ['quality-product-manage']
            },
          ]
        },
        {
          name:'返回系统',
          href:  this.$httpConfig.COLAHOST + 'Purchasing/',
          icon: ('/static/images/home/nav-icon.png'),
          subItems: []
        }
      ],
      // su
      suMenuList:[
        {
          name:'质量检测',
          icon: ('/static/images/home/product-detect.png'),
          activeIcon: ('/static/images/home/product-detect-active.png'),
          isSubShow:false,
          subItems:[
            {
              name:'质量检测订单',
              routerName: 'su-order-qualify',
              routerActiveList: ['su-order-qualify', 'su-review-qualify', 'su-apply-check']
            },
          ]
        },
        {
          name: '实验室列表',
          icon: ('/static/images/home/product.png'),
          activeIcon: ('/static/images/home/product-active.png'),
          subItems: [],
          routerName: 'su-examine-tl',
          routerActiveList: ['su-examine-tl', 'su-tllist-detail']
        },
        {
          name:'返回系统',
          icon: ('/static/images/home/nav-icon.png'),
          href:  this.$httpConfig.COLAHOST + 'Vendor/',
          subItems: []
        }
      ],
      //tl
      tlMenuList:[
        {
          name:'质量检测',
          icon: ('/static/images/home/product-detect.png'),
          activeIcon: ('/static/images/home/product-detect-active.png'),
          isSubShow: true,
          subItems:[
            {
              name:'质量检测订单',
              routerName: 'order-qualify',
              routerActiveList: ['order-qualify', 'review-qualify', 'tl-apply-check']
            },
            {
              name:'提交质量检测报告',
              routerName: 'report-qualify',
              routerActiveList: ['report-qualify']
            },
            // {
            //   name:'质量报告',
            //   routerName: 'qualify-report',
            // },
          ]
        },
        {
          name:'返回系统',
          icon: ('/static/images/home/nav-icon.png'),
          href:  this.$httpConfig.COLAHOST + 'TL/',
          subItems: []
        }
      ]
    }
  },
  computed: {
    currentSubShow(item) {
      return (item) => {
        return item.isSubShow && this.currentRoute
      }
    },
    currentRoute(item) {
      return (item) => {
        if (!item.subItems.length) {
          if (item.routerActiveList && item.routerActiveList.includes(this.$route.name)) {
            return true
          }
          return false
        } else {
          return item.subItems.some((value) => value.routerActiveList && value.routerActiveList.includes(this.$route.name))
        }
        return false
      }
    }
  },
  methods:{
    roleHandle() {
      let role = ''
      if (this.$route.query.sgp_user) {
        role = 'sgp_user'
      } else if (this.$route.query.tl_user) {
        role = 'tl_user'
      } else if (this.$route.query.su_user) {
        role = 'su_user'
      }
      return {[role]: true}
    },
    // goTop
    goTop(){
      if(document.documentElement.scrollTop){
        document.documentElement.scrollTop = 0
      }else{
        document.body.scrollTop =0
      }
    },
    // sgp点击展开折叠菜单事件
    showToggle(item){
      this.menuList.forEach((value) => {
        if (item.name !== value.name) {
          value.isSubShow = false
        }
      })
      item.isSubShow = !item.isSubShow
    },
    routerConfig(item, index){

    },
  },

  created(){
    let name = this.$route.name
    // this.routeJump(name)
    let menuList = []
    if(this.$route.query.su_user){
      this.menuList = this.suMenuList
    }else if(this.$route.query.sgp_user){
      this.menuList = this.sgpMenuList
    }else if(this.$route.query.tl_user){
      this.menuList = this.tlMenuList
    }
    this.menuList.forEach((item) => {
      if (!item.subItems.length) {
        if (item.routerActiveList && item.routerActiveList.includes(this.$route.name)) {
          item.isSubShow = true
          return true
        }
        item.isSubShow = false
      } else {
        item.isSubShow = item.subItems.some((value) => value.routerActiveList && value.routerActiveList.includes(this.$route.name))
      }
    })
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', () => {
      this.scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
      // 控制滚动按钮的隐藏或显示
      if (this.scrollTop > 900) {
        this.scroll_top_show = true
      } else if(this.scrollTop < 900){
        this.scroll_top_show = false
      }
    }, true)
  }
}
</script>

<style scoped lang="scss">
  .grid-content {
    width: 1026px;
  }
  .go-top{
    width: 50px;
    height: 50px;
    border-radius: 2px;
    background-color: #b3b3b3;
    position: fixed;
    bottom: 60px;
    right: 0px;
    cursor: pointer;
    line-height: 50px;
    .go-top-img{
      margin-top: 13px;
      margin-left: 13px;
      width: 24px;
      height: 24px;
      background: url('/static/images/home/totop.png') center no-repeat;
      background-size: 24px 24px;
    }
  }
  .rotate_img{
    transform: rotate(180deg)
  }
  .container{
    min-width: 1200px;
    margin: 0 auto;
    box-shadow: 0 2px 6px 0 rgba(166, 166, 166, 0.32);
    background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
  }
  .topbar-wrap{
    width: 1200px;
    margin:0 auto;
    background-color: #fff;
    cursor: pointer;
    border-radius: 2px;
  }
  .topbar-title{
    height: 60px;
    line-height: 60px;
    font-family: 'PingFangSC';
    font-size: 20px;
    font-weight: 500;
    margin-left: 45px;
  }
  .topbar-logo{
    height: 60px;
    line-height: 60px;
    margin-left: 32px;
  }
  .topbar-logo img{
    width: 112px;
    height: 36px;
  }
  // 侧边栏
  $menuBackColor: #fff;
  $menuListH2:#455560;
  $menuword: #f40009;
  $childmenu: #f8f8f8;
  .menuActive{
    color:  $menuword !important;
    background-color: rgba(244,0,9,0.1) !important;
    border-left: 4px solid $menuword;
  }
  .router-link-active .nav-text{
    color: $menuword !important;
   }
  .router-link-active .nav-cicle{
    border-color: $menuword !important;
   }
  .main-container {
    position: absolute;
    width: 100%;
    top: 60px;
    bottom: 0;
    overflow: auto;
  }
  .content-container {
    width: 1000px;
    padding-bottom: 30px;
  }
  .main{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    min-height: 100%;
    justify-content: space-between;
  }
  .asideBox{
    width: 200px;
    border-radius: 2px;
    box-shadow: 0 2px 6px 0 rgba(166, 166, 166, 0.32);
    aside{
      background: $menuBackColor;
      height: 100%;
      .asideMenu{
        .oneMenu{
          cursor: pointer;
          height: 48px;
          line-height: 48px;
          font-family: 'PingFangSC';
          font-size: 16px;
          font-weight: 500;
          color: $menuListH2;
          background-color: $menuBackColor;
          padding-left: 16px;
          img{
            width: 24px;
            height: 24px;
          }
          span{
            display: inline-block;
            padding-left: 8px;
          }
          a{
            display: inline-block;
            padding-left: 8px;
            color: #455560;
          }
          .arrow-img{
            width: 16px;
            height: 16px;
            margin-right: 12px;
            margin-top: 16px;
          }
        }
        .oneMenuChild{
          display: block;
          padding-left: 32px;
          height: 40px;
          line-height: 40px;
          background: $menuBackColor;
          color: $menuListH2;
          font-size: 14px;
          font-weight: 500;
          background-color: $childmenu;
          cursor: pointer;
          .nav-cicle{
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 6px;
            border: 2px solid $menuListH2;
            margin-right: 8px;
          }
        }
        .oneMenuChild:hover{
          color: $menuword;
        }
        .oneMenuChild:hover .nav-cicle {
          border-color: $menuword !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue